export default "__VITE_ASSET__DruB4vmU__"